import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateNewIndependentLesson extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("IndependentLesson/Create");
  }
  setFormData(data) {
    super.setFormData(data);
  }
}

class GetIndependentLessonsList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("IndependentLesson/GetList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAnIndependentLesson extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("IndependentLesson/GetById");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateAnIndependentLesson extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("IndependentLesson/Update");
  }
  setFormData(data) {
    super.setFormData(data);
  }
}

class DeleteAnIndependentLesson extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("IndependentLesson/Delete");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  CreateNewIndependentLesson,
  GetIndependentLessonsList,
  GetAnIndependentLesson,
  UpdateAnIndependentLesson,
  DeleteAnIndependentLesson,
};
